import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, TextField } from '@ann/web-components';
import { ErrorMessage } from './RenameModal.styled';

const CONFIG = {
    drive: {
        title: 'Rename drive',
        label: 'Drive Name',
        placeholder: 'Untitled Drive',
        errorMessage: 'Drive name is required',
    },
    folder: {
        title: 'Rename folder',
        label: 'Folder Name',
        placeholder: 'Untitled folder',
        errorMessage: 'Folder name is required',
    },
    document: {
        title: 'Rename document',
        label: 'Document Name',
        placeholder: 'Untitled document',
        errorMessage: 'Document name is required',
    },
};

const RenameModal = observer(({ store, size = 'medium', modalWidth = '500px' }) => {
    const config = CONFIG[store.type] || CONFIG.document;
    const [touched, setTouched] = useState(false);

    const isFieldEmpty = !store.currentName.trim();
    const showError = touched && isFieldEmpty;

    // Reset touched state when modal opens/closes
    useEffect(() => {
        if (store.isOpen) {
            setTouched(false);
        }
    }, [store.isOpen]);

    const handleCancel = () => {
        setTouched(false);
        store.close();
    };

    const handleConfirm = () => {
        if (!store.isValid || store.isSubmitting) return;
        store.confirm();
    };

    const handleNameChange = (value) => {
        store.setCurrentName(value);
        if (!touched && value.length > 0) {
            setTouched(true);
        }
    };

    return (
        <Modal isOpen={store.isOpen} onClose={handleCancel} width={modalWidth} size={size}>
            <Modal.Header>
                <Modal.Header.Title>{config.title}</Modal.Header.Title>
            </Modal.Header>

            <Modal.Body>
                <TextField
                    label={config.label}
                    size="small"
                    placeholder={config.placeholder}
                    value={store.currentName}
                    onChange={handleNameChange}
                    autoFocus
                    required
                />
                {showError && (
                    <ErrorMessage>{config.errorMessage}</ErrorMessage>
                )}
            </Modal.Body>

            <Modal.Actions align="end">
                <Modal.Button
                    label="Cancel"
                    type="secondary"
                    onClick={handleCancel}
                />
                <Modal.Button
                    label={store.isSubmitting ? 'Saving…' : 'Save'}
                    onClick={handleConfirm}
                    disabled={!store.isValid || store.isSubmitting}
                />
            </Modal.Actions>
        </Modal>
    );
});

export default RenameModal;


